import React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import ContainerForClinicUser from "./ContainerForClinicUser";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectClinicHasMore,
  selectClinicUserList,
  selectLoading,
  selectSortConfig,
} from "store/ClinicStore/selectors";
import {
  loadMoreClinicUsers,
  changeSortOfClinicUserList,
} from "store/ClinicStore/actions";
import { StatusENUM } from "types/common";

const ClinicListContainer: React.FC<{
  disableUser: (userId: string, status?: StatusENUM) => void;
  editUser: (userId: string) => void;
  resendInvitation: (email: string,role:any) => void;
}> = ({ disableUser, editUser, resendInvitation }) => {
  const dispatch = useAppDispatch();
  const clinicUserList = useAppSelector(selectClinicUserList);
  const hasMoreItems = useAppSelector(selectClinicHasMore);
  const sortConfig = useAppSelector(selectSortConfig);
  const isLoading = useAppSelector(selectLoading);

  const onClick = (sortBy: string) => {
    dispatch(changeSortOfClinicUserList(sortBy));
  };

  const onLoadMore = React.useCallback(() => {
    dispatch(loadMoreClinicUsers());
  }, [dispatch]);

  return isLoading ? (
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginTop: "40px",
    }}
  >
    <CircularProgress color="inherit" size={50} />
  </div>
  ) : (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      <ContainerForClinicUser
        clinicUserList={clinicUserList}
        onClick={onClick}
        sortConfig={sortConfig}
        loading={isLoading}
        onLoadMore={onLoadMore}
        hasMoreItems={hasMoreItems}
        editUser={editUser}
        disableUser={disableUser}
        resendInvitation={resendInvitation}
      />
    </div>
  );
};

export default ClinicListContainer;
